import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { App } from "@capacitor/app";
import { ConfigService } from 'src/app/services/config/config.service';
import { BiometricService } from 'src/app/services/biometric/biometric.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  protected userID: number;
  protected isAuthenticated: boolean = false;
  public customer: CustomerModel;
  public isPlayerLoggedInAsGuest: boolean = false;
  public isPlayerFirstVisit: boolean = false;
  public isCustomerHasEmail: boolean = null;
  public platformID: any;
  public playerHasRewardCard: boolean = true;
  public isMobileApp: boolean;
  public versionNumber: string;
  public feautureCustomerSupportURL: string;
  public featureTermsAndConditionURL: string;
  public featurePrivacyURL: string;
  public featureResponsibleGamingURL: string;
  public isApp: boolean = false;
  constructor(
    private readonly appLinks: AppLinksService,
    private readonly logoutService: LogoutService,
    private readonly navigator: Navigator,
    private readonly userSessionService: UserSessionService,
    private readonly authenticationService: AuthenticationService,
    private biometricService: BiometricService,
    private appStorageService: AppstorageTsService,
    private config: ConfigService,
    private platform: Platform
  ) {
    this.verifyAuth();

    this.userSessionService.getCustomerPromise().then((customer: CustomerModel) => {
      if(customer){
        this.customer = customer;
        this.isCustomerHasEmail = isUndefined(customer.email)
        this.userID = customer.customerId;
        this.checkPlayerHasRewardCard();
      }
    }).catch(error => {
      console.log('something went wrong', error)
    })
    this.isApp = this.platform.is("capacitor");
    /*this.userSessionService.getCustomer().subscribe(
      (customer) => {
        if (customer) {
          this.customer = customer;
          this.isCustomerHasEmail = isUndefined(customer.email)
          this.userID = customer.customerId;
          this.checkPlayerHasRewardCard();
        }
      }, (err) => {
        console.error("getCustomer", err);
      }
    );*/
  }
	async checkBiometricAvailable() {
		this.biometricService.verificationError = null;
		await this.biometricService.isAvailable();
	}
  async ngOnInit() {
    if(this.isApp){
      await this.checkBiometricAvailable();
    }
    this.appStorageService.getPlayerAsGuest().then((isGuest) => {
      if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
      return this.isPlayerLoggedInAsGuest = false;
    })

    this.platformID = (await this.appStorageService.getPlayerPlatformID()).value;
    if (this.platformID !== null) {
      this.isPlayerFirstVisit = false;
    } else {
      this.isPlayerFirstVisit = true;
    }
    this.checkVersionNumber();
    this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL;
    this.featureTermsAndConditionURL = this.config.getConfig().FEATURE_SITE_TERMS_LINK;
    this.featurePrivacyURL = this.config.getConfig().FEATURE_SITE_PRIVACY_LINK;
    this.featureResponsibleGamingURL = this.config.getConfig().FEATURE_SITE_RESPONSIBLE_GAMING_LINK;
  }

  private async checkVersionNumber() {
    this.versionNumber = "N/A";
    if (this.platform.is("capacitor")) {
      this.isMobileApp = true;
      const info = await App.getInfo()
      this.versionNumber = info.version;
    } else {
      this.isMobileApp = false;
    }
  }

  protected closeSettings() {
    return this.navigator.dismissAll();
  }

  private checkPlayerHasRewardCard() {
    this.authenticationService.checkPlayerHasRewardCard().subscribe(
      (response) => {
        if (response && !!response.result) {
          this.playerHasRewardCard = response.payload;
        }
      },
      (error) => {
        this.playerHasRewardCard = false;
      }
    );
  }

  private verifyAuth(): any {
    this.userSessionService.isAuthenticated().then((auth) => {
      if (auth) return this.isAuthenticated = true;
      return this.isAuthenticated = false;
    })
  }

  protected onLogout(): any {
    return this.logoutService.onLogout();
  }

  public navigateTo(page: string, customModalClass?: string, animated?: boolean) {
    this.navigator.dismissAll();
    return this.navigator.navigateTo(page, { customModalClass: customModalClass, animated: animated });
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

}

